import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'itl-detail-title',
  templateUrl: './detail-title.component.html',
  styleUrls: ['./detail-title.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class DetailTitleComponent {}
